var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarOutline({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-star-outline",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5,8.2c0-0.5-0.2-1-0.6-1.4c-0.3-0.2-0.6-0.4-1-0.5l-3.6-0.6l-1.6-3.5c-0.4-1-1.5-1.4-2.4-1 c-0.5,0.2-0.8,0.6-1,1L6.7,5.7L3,6.3C1.9,6.5,1.3,7.6,1.5,8.7C1.6,9.1,1.8,9.4,2,9.6l2.6,2.8L4,16.3c-0.2,1,0.4,2.1,1.4,2.3 c0.4,0.1,0.9,0,1.3-0.2l3.2-1.8l3.2,1.9c0.3,0.1,0.6,0.2,0.9,0.2c0.2,0,0.4,0,0.6-0.1c0.5-0.2,0.9-0.5,1.1-1 c0.2-0.4,0.3-0.9,0.2-1.2l-0.6-4L18,9.6C18.4,9.2,18.6,8.7,18.5,8.2z M13.2,11.8l0.8,4.9l-4-2.3l-4,2.3l0.8-4.9L3.4,8.3L8,7.5l2-4.3 l2,4.3l4.6,0.7L13.2,11.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarOutline);
export default __webpack_public_path__ + "static/media/starOutline.65b93405bc7231cea8c44ce0a6cf3084.svg";
export { ForwardRef as ReactComponent };